
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#EC2F3B","stroke-width":"1.326","fill":"none","fill-rule":"evenodd","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-linecap":"round","d":"M18.954 2.386l1.988 2.652h-6.628M18.955 7.689l1.988-2.651"}}),_c('path',{attrs:{"d":"M3.708 3.712a2.652 2.652 0 105.303 0 2.652 2.652 0 00-5.303 0h0zM6.36 7.023a5.303 5.303 0 00-5.303 5.303v1.988c0 .733.593 1.326 1.326 1.326h1.325v3.977c0 .733.594 1.326 1.326 1.326h2.652c.732 0 1.325-.593 1.325-1.326V15.64h1.326c.732 0 1.326-.593 1.326-1.326v-1.988A5.303 5.303 0 006.36 7.023z"}})])])
          )
        }
      }
    